document.addEventListener("DOMContentLoaded", function(){
	'use strict'

  // Class constructor for Komodo List component.
  // Implements Komodo component design pattern
  //
  // @constructor
  // @param {HTMLElement} The element that will be upgraded to be Komodo Accordion.
  var KomodoList = function KomodoList(element) {
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    this.element_ = element;
    this.items = isIE11 ? this.element_.querySelectorAll("." + this.cssClasses_.ITEMS) : this.element_.querySelectorAll(':scope > .'+this.cssClasses_.ITEMS);
    this.currentItem = null;
    this.element_.addEventListener('keydown', this.onKeyDown.bind(this));
  };
  window['KomodoList'] = KomodoList

  // Store strings for class names defined by this component that are used in
  // Javascript. This allows us to simply change it in one place should we decide
  // to modify at a later date.
  //
  // @enum {string}
  // @private
  KomodoList.prototype.cssClasses_ = {
    ITEMS: 'list-item',
    TEXT: 'list-item--text',
  };

  // Store strings for keycodes defined for this component that are used in 
  // Javascript. This allows us to enable keyboard navigation for the component.
  
  // @enum {string}
  // @private
  KomodoList.prototype.keyCodes = {
    ENTER: 13,
    SPACE: 32,
    END: 35,
    HOME: 36,
    ARROW_LEFT: 37,
    ARROW_UP: 38,
    ARROW_RIGHT: 39,
    ARROW_DOWN: 40
  }

  // Bind the keyboard events with the lists.
  // 
  // @public
  KomodoList.prototype.onKeyDown = function (event) {
    switch(event.keyCode){
    case this.keyCodes.ARROW_UP:
    	event.preventDefault();
    	switch(this.currentItem){
    	case null:
    		this.items[0].focus();
    		this.currentItem = 0;
    		break;
    	case 0:
    		event.preventDefault();
    		break;
    	default:
    		this.currentItem = this.currentItem-1;
    		this.items[this.currentItem].focus();
    	}
    	break;
    case this.keyCodes.ARROW_DOWN:
    	event.preventDefault();
    	switch(this.currentItem){
    	case null:
    		this.items[0].focus();
    		this.currentItem = 0;
    		break;
    	case (this.items.length-1):
    		event.preventDefault();
    		break;
    	default:
    		this.currentItem = this.currentItem+1;
    		this.items[this.currentItem].focus();
    	}
    	break;
    case this.keyCodes.HOME:
    	event.preventDefault();
    	this.items[0].focus();
    	this.currentItem = 0;
    	break;
    case this.keyCodes.END:
      event.preventDefault();
    	this.currentItem = (this.items.length - 1);
    	this.items[this.currentItem].focus();
    	break;
    case this.keyCodes.SPACE:
    case this.keyCodes.ENTER:
    	event.preventDefault();
    	//this.items[this.currentItem].querySelector('.'+this.cssClasses_.TEXT).click();
    	break;
    }
  }

  // Focus on 

  // The component registers itself. It can assume componentHandler is available
  // in the global scope.
  componentHandler.register({
    constructor: KomodoList,
    classAsString: 'KomodoList',
    cssClass: 'list',
    widget: true
  })
})